import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGlobalState } from './types';
import initialGlobalState from './initialState';
import { IFilters, ThemeList } from '../globalTypes';
import { ITableFilters } from './types';

const globalSlice = createSlice({
  name: 'global',
  initialState: initialGlobalState(),
  reducers: {
    set_applied_filters_result(state: any, action: PayloadAction<any[]>) {
      state.appliedFiltersResult = Object.values(action.payload);
      state.error = false;
      state.loading = false;
    },
    set_filters_data(state: any, action: PayloadAction<IFilters[]>) {
      state.filtersData = action.payload;
      state.error = false;
      state.loading = false;
    },
    set_filters_data_lei(state: any, action: PayloadAction<IFilters[]>) {
      state.filtersDataLei = action.payload;
      state.error = false;
      state.loading = false;
    },
    set_table_filters(state: any, action: PayloadAction<ITableFilters>) {
      state.tableFilters = { ...state.tableFilters, ...action.payload };
      state.error = false;
      state.loading = false;
    },
    set_loading(state: IGlobalState) {
      state.loading = true;
    },
    set_error(state: IGlobalState, action: PayloadAction<any>) {
      state.error = action.payload;
      state.loading = false;
    },
    set_theme(state: IGlobalState, action: PayloadAction<ThemeList>) {
      state.scheme = action.payload;
      state.loading = false;
    },
    set_selectedOption99(state: IGlobalState, action: PayloadAction<any>) {
      state.selectedOption99 = action.payload;
    },
    set_superAdmin(state: IGlobalState, action: PayloadAction<boolean>) {
      state.superAdmin = action.payload;
    },
  },
});

export const {
  set_filters_data,
  set_applied_filters_result,
  set_table_filters,
  set_loading,
  set_error,
  set_theme,
  set_selectedOption99,
  set_superAdmin,
  set_filters_data_lei,
} = globalSlice.actions;

export default globalSlice;
